import { setFontDetailsToContext } from './set-font-details-to-context.js';
import {
  HONEYCOMB_DEFAULT_MIN_ELLIPSIZED_TEXT,
  HONEYCOMB_LABEL_FONT_SIZE,
  HONEYCOMB_VALUE_LABEL_FONT_SIZE,
} from '../../../constants.js';
import { CanvasTextAreaProps } from '../../../types/canvas-text-area.js';

export const measureNodeTextContent = (
  ctx: CanvasRenderingContext2D,
  value: string | number,
  name: string,
  textArea: CanvasTextAreaProps,
) => {
  setFontDetailsToContext(ctx, 'label');
  const nameSizes = ctx.measureText(name);
  const minNameWidth = ctx.measureText(
    HONEYCOMB_DEFAULT_MIN_ELLIPSIZED_TEXT,
  ).width;

  setFontDetailsToContext(ctx, 'value');
  const valueSizes = ctx.measureText(value.toString());
  const minValueWidth = ctx.measureText(
    HONEYCOMB_DEFAULT_MIN_ELLIPSIZED_TEXT,
  ).width;

  const valueHeight = HONEYCOMB_VALUE_LABEL_FONT_SIZE;
  const valueWidth = valueSizes.width;
  const isValueHeightFitting = valueHeight < textArea.height;
  const ableToRenderValue =
    isValueHeightFitting && typeof value === 'string'
      ? textArea.width > minValueWidth
      : valueWidth < textArea.width;

  const nameHeight = HONEYCOMB_LABEL_FONT_SIZE;
  const isNameHeightFitting = nameHeight < textArea.height;
  const nameWidth = nameSizes.width;
  const ableToRenderName = isNameHeightFitting && textArea.width > minNameWidth;

  const totalHeight = valueHeight + valueHeight * 0.5 + nameHeight;
  const ableToRenderNothing = !ableToRenderValue && !ableToRenderName;
  const ableToRenderBoth =
    totalHeight < textArea.height && ableToRenderValue && ableToRenderName;

  return {
    valueHeight,
    nameHeight,
    ableToRenderNothing,
    ableToRenderBoth,
    valueWidth,
    nameWidth,
    ableToRenderName,
    ableToRenderValue,
  };
};
